import PageBody from "../components/ui/layout/PageBody";
import { useAuth } from "../providers/AuthProvider";

export default function NoPermission() {
    const { logout, account } = useAuth();

    return (
        <PageBody>
            <div className="mx-auto max-w-md">
                <div className="flex flex-col items-center gap-4 text-center">
                    <img
                        src="/request-denied.gif"
                        alt="That Request Is Denied"
                        className="w-96 rounded-lg"
                    />
                    {account?.username && (
                        <p className="text-gray-500 text-sm">{account.username}</p>
                    )}
                    <p className="text-gray-600">
                        Your account does not have any roles assigned.
                    </p>
                    <p className="text-gray-600 text-sm">
                        Please contact your supervisor to request access.
                    </p>
                    <button
                        onClick={logout}
                        className="mt-4 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    >
                        Sign out
                    </button>
                </div>
            </div>
        </PageBody>
    );
}
